import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  async change_seq(event) {
    if (event.type === 'keydown' && event.keyCode !== 13) {
      return;
    }
    const element = this.element;
    let href = element.dataset.href;
    let seq = element.value;
    href += '&seq=' + seq;
    event.preventDefault();
    $.ajax({
      method: 'PATCH',
      url: href,
      dataType: 'json',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: function(result) {
        Swal.fire('Success!', result.message || '', 'success')
            .then((_result) => {
                    if (result.redirect_path == null){
                        window.location.reload();
                    } else{
                        window.location.assign(result.redirect_path)
                    }
            });
      },
      error: function (xhr) {
        console.log(xhr);
      }

    });



  }
}
